// extracted by mini-css-extract-plugin
export default {"form-modal":"FormModal_form-modal__HW2r6","form-modal--no-fade":"FormModal_form-modal--no-fade__c3vNH","form-modal__buttons":"FormModal_form-modal__buttons__iJDZ3"};